export { CallState } from '../../features/call/call.types';

import {
  setIsChatOpen,
  setActiveUserAccordionId,
  setIsPictureInPictureStarted,
} from '../../features/uiState/uiState.slice';
import { useAppDispatch } from '../useReduxToolkit';

type Return = {
  setChatOpen: (value: boolean) => void;
  setActiveUserAccordionId: (value: string | undefined) => void;
  setPictureInPictureStarted: (value: boolean) => void;
};

export const useUIState = (): Return => {
  const dispatch = useAppDispatch();

  return {
    setChatOpen: (value) => dispatch(setIsChatOpen(value)),
    setActiveUserAccordionId: (value) =>
      dispatch(setActiveUserAccordionId(value)),
    setPictureInPictureStarted: (value) =>
      dispatch(setIsPictureInPictureStarted(value)),
  };
};
